module.exports = __webpack_public_path__ + "static/media/tire-tread-depth.918f6434.svg";